import { Injectable } from '@angular/core';
import { DataService } from '../../architecture/data.service';
import { Result } from '../../architecture/envelopes';
import { Status } from 'src/app/shared/models/status.model';

@Injectable({ providedIn: 'root' })
export class StatusService {
    constructor(private dataService: DataService) { }

    public get() {
        return this.dataService.get<Result<Status>>('status');
    }

    public delete(cod: number) {
        return this.dataService.delete<Result<string>>('status/' + cod.toString());
    }

    public insert(status: Status) {
        return this.dataService.post<Result<Status>>('status', status);
    }

    public update(status: Status) {
        return this.dataService.put<Result<Status>>('status', status);
    }
}
